var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.fetchedData),function(object){return _c('div',{staticClass:"col-6"},[_vm._t("gridRepresentationCard",null,null,object)],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }